import config from '../../config/config';

const BASE_URL = config.API_BASE_URL;
const APP_PREFIX = 'app/';
const HUB_URL = config.HUB_BASE_URL;

export const apiVariables = {
  BASE_URL: BASE_URL,

  ATTCH_AUTH_CLAIMS_IN_TOKEN: `${BASE_URL}${APP_PREFIX}Auth/attach-claims-app`,
  GET_NONCE: `${BASE_URL}${APP_PREFIX}Auth/nonce`,
  REGISTER_WITH_FIREBASE: `${BASE_URL}${APP_PREFIX}Registration/registerWithFirebase`,
  AUTH_LOGIN: `${BASE_URL}${APP_PREFIX}Auth/login`,
  AUTH_REGISTER: `${BASE_URL}${APP_PREFIX}Auth/register`,
  AUTH_LOGOUT: `${BASE_URL}${APP_PREFIX}Auth/logout`,
  AUTH_REFRESH_TOKEN: `${BASE_URL}${APP_PREFIX}Auth/refresh-token`,
  AUTH_FORGOT_PASSWORD: `${BASE_URL}${APP_PREFIX}Auth/forgot-password/request-otp`,
  AUTH_RESET_PASSWORD: `${BASE_URL}${APP_PREFIX}Auth/reset-password`,
  AUTH_VERIFY_EMAIL: `${BASE_URL}${APP_PREFIX}Auth/verify-email`,
  AUTH_Forgot_VERIFY_EMAIL: `${BASE_URL}${APP_PREFIX}Auth/forgot-password/verify-otp`,
  AUTH_Forgot_SET_PASSWORD: `${BASE_URL}${APP_PREFIX}Auth/forgot-password/set-password`,
  AUTH_CHANGE_PASSWORD: `${BASE_URL}${APP_PREFIX}Auth/change-password`,
  AUTH_CHECK_EMAIL: `${BASE_URL}${APP_PREFIX}Auth/check-email`,
  AUTH_VALIDATE_LICENSE: `${BASE_URL}${APP_PREFIX}Auth/validate-license`,


  REGISTRATION_VALIDATE_EMAIL: `${BASE_URL}${APP_PREFIX}Registration/validate-email`,
  REGISTRATION_GENERATE_TOKEN: `${BASE_URL}${APP_PREFIX}GenerateToken/generate-token`,
  REGISTRATION_CONFIRM_EMAIL: `${BASE_URL}${APP_PREFIX}Registration/confirm-email`,
  REGISTRATION_SET_PASSWORD: `${BASE_URL}${APP_PREFIX}Registration/set-password`,
  REGISTRATION_RESEND_OPT: `${BASE_URL}${APP_PREFIX}Registration/resend-otp`,

  USER_PROFILE: `${BASE_URL}${APP_PREFIX}User/profile`,
  USER_UPDATE: `${BASE_URL}${APP_PREFIX}User/update`,
  USER_UPLOAD_PHOTO: `${BASE_URL}${APP_PREFIX}User/upload-photo`,
  USER_DELETE_PHOTO: `${BASE_URL}${APP_PREFIX}User/delete-photo`,
  USER_BY_ID: (id: string) => `${BASE_URL}${APP_PREFIX}User/${id}`,

  MATCH_FETCH: `${BASE_URL}${APP_PREFIX}Match/fetch`,
  MATCH_LIKE: `${BASE_URL}${APP_PREFIX}Match/like`,
  MATCH_PASS: `${BASE_URL}${APP_PREFIX}Match/pass`,
  MATCH_UNDO: `${BASE_URL}${APP_PREFIX}Match/undo`,
  MATCH_MUTUAL: `${BASE_URL}${APP_PREFIX}Match/mutual`,
  MATCH_BY_ID: (id: string) => `${BASE_URL}${APP_PREFIX}Match/${id}`,

  MESSAGE_CONVERSATIONS: `${BASE_URL}${APP_PREFIX}Messages/conversations`,
  MESSAGE_SEND: `${BASE_URL}${APP_PREFIX}Messages/send`,
  MESSAGE_MARK_READ: `${BASE_URL}${APP_PREFIX}Messages/mark-read`,
  MESSAGE_DELETE: `${BASE_URL}${APP_PREFIX}Messages/delete`,
  MESSAGE_BY_CONVERSATION: (conversationId: string) =>
    `${BASE_URL}${APP_PREFIX}Messages/conversation/${conversationId}`,

  SETTINGS_GET: `${BASE_URL}${APP_PREFIX}Settings`,
  SETTINGS_UPDATE: `${BASE_URL}${APP_PREFIX}Settings/update`,
  SETTINGS_PREFERENCES: `${BASE_URL}${APP_PREFIX}Settings/preferences`,
  SETTINGS_NOTIFICATIONS: `${BASE_URL}${APP_PREFIX}Settings/notifications`,
  SETTINGS_PRIVACY: `${BASE_URL}${APP_PREFIX}Settings/privacy`,

  NOTIFICATION_LIST: `${BASE_URL}${APP_PREFIX}notifications`,
  NOTIFICATION_MARK_READ: (id: string) => `${BASE_URL}${APP_PREFIX}notifications/${id}/read`,
  NOTIFICATION_MARK_ALL_READ: `${BASE_URL}${APP_PREFIX}notifications/read-all`,
  NOTIFICATION_DELETE: `${BASE_URL}${APP_PREFIX}Notifications/delete`,
  NOTIFICATION_BY_ID: (id: string) => `${BASE_URL}${APP_PREFIX}Notifications/${id}`,
  ASK_ISENTRYX_AI_SEARCH: `${BASE_URL}ask-isentryx-ai/search`,
  WORKFORCE_INTELLIGENCE_DASHBOARD: `${BASE_URL}${APP_PREFIX}workforce-intelligence/dashboard`,

  SPECIALTY_LIST: `${BASE_URL}${APP_PREFIX}Specialties`,
  SPECIALTY_CATEGORIES: `${BASE_URL}${APP_PREFIX}Specialties/categories`,
  SPECIALTY_BY_ID: (id: string) => `${BASE_URL}${APP_PREFIX}Specialties/${id}`,

  FEEDBACK_SUBMIT: `${BASE_URL}${APP_PREFIX}Feedback`,

  REPORT_SUBMIT: `${BASE_URL}${APP_PREFIX}report-user`,
  REPORT_USER: `${BASE_URL}${APP_PREFIX}Report/user`,
  BLOCK_USER: `${BASE_URL}${APP_PREFIX}Block/user`,
  UNBLOCK_USER: `${BASE_URL}${APP_PREFIX}Block/unblock`,
  BLOCKED_LIST: `${BASE_URL}${APP_PREFIX}Block/list`,

  GetAppFieldSetting: `${BASE_URL}app/Masters/FieldSettings`,

  Admin_WorkShift: `${BASE_URL}app/Masters/WorkShift`,
  ADMIN_RELIGIOUSASSOCIATION: `${BASE_URL}app/Masters/ReligiousAssociation`,
  Admin_Genders: `${BASE_URL}app/Masters/Genders`,
  ADMIN_ETHNICITY: `${BASE_URL}app/Masters/Ethnicity`,
  Admin_MaritalStatus: `${BASE_URL}app/Masters/MaritalStatus`,
  Admin_ITSpecialty: `${BASE_URL}app/Masters/ItSpecialties`,
  Admin_AttractiveAppearance: `${BASE_URL}app/Masters/AttractiveAppearance`,
  Admin_ITSkills: `${BASE_URL}app/Masters/ItSkills`,
  Admin_WorkTypes: `${BASE_URL}app/Masters/WorkTypes`,

  Admin_SaveUserDetail: `${BASE_URL}${APP_PREFIX}UserProfiles/CreateProfile`,
  Admin_GetUserDetail: `${BASE_URL}${APP_PREFIX}UserProfiles/summary`,
  Admin_UploadUserImage: `${BASE_URL}${APP_PREFIX}UserImages/upload-multiple`,
  Admin_DeleteUserImage: `${BASE_URL}${APP_PREFIX}UserImages/`,
  Admin_SetMainProfileImage: `${BASE_URL}${APP_PREFIX}UserImages/set-profile-photo`,
  GetPhotoSasUrlByPhotoId: `${BASE_URL}${APP_PREFIX}UserImages/GetPhotosByPhotoId/`,
  GetPhotoUrlByPhotoId: `${BASE_URL}${APP_PREFIX}UserImages/GetPhotoSasUrlByPhotoId/`,

  UserProfile_GetByUserId: `${BASE_URL}${APP_PREFIX}UserProfiles/GetbyuserId/`,
  UserProfile_GetbymatchuserId: `${BASE_URL}${APP_PREFIX}UserProfiles/GetbymatchuserId/`,
  UserAvailabilitySync: `${BASE_URL}${APP_PREFIX}UserAvailability/sync`,
  UserAvailability: `${BASE_URL}${APP_PREFIX}UserAvailability`,
  UserAvailabilityPending: `${BASE_URL}${APP_PREFIX}UserAvailability/pending`,
  UserAvailabilityApprove: `${BASE_URL}${APP_PREFIX}UserAvailability/approve`,
  UserAvailabilityReject: `${BASE_URL}${APP_PREFIX}UserAvailability/reject`,
  UserAvailabilityHistory: `${BASE_URL}${APP_PREFIX}UserAvailability/history`,

  SkillApprovalList: `${BASE_URL}${APP_PREFIX}skill-approval`,
  SkillApprovalApprove: `${BASE_URL}${APP_PREFIX}skill-approval/approve`,
  SkillApprovalReject: `${BASE_URL}${APP_PREFIX}skill-approval/reject`,

  GetMatches: `${BASE_URL}${APP_PREFIX}Matches`,
  SaveMatches: `${BASE_URL}${APP_PREFIX}UserMatchingPreference`,
  GetUserMatchingPreferences: `${BASE_URL}${APP_PREFIX}UserMatchingPreference/`,
  GetRefineMatches: `${BASE_URL}${APP_PREFIX}FindConnections/find-connections`,
  GetMessageList: `${BASE_URL}${APP_PREFIX}messages/list`,

  GetMessageHistory: `${BASE_URL}${APP_PREFIX}messages/history`,
  GetGroupMessages: `${BASE_URL}${APP_PREFIX}messages/group`,

  POST_CREATE_WITH_MEDIA: `${BASE_URL}${APP_PREFIX}Posts/create-with-media`,
  POST_UPDATE_WITH_MEDIA: `${BASE_URL}${APP_PREFIX}Posts/update-with-media`,
  POST_GET_BY_ID: `${BASE_URL}${APP_PREFIX}Posts/`,
  POST_ATTACHMENT_SAS_URL: `${BASE_URL}${APP_PREFIX}Posts/attachment/`,
  ViewPosts: `${BASE_URL}${APP_PREFIX}Posts/paged`,
  TrendingHashtags: `${BASE_URL}${APP_PREFIX}Posts/hashtags/trending`,
  GetTrendingByHashtag: `${BASE_URL}${APP_PREFIX}Posts/hashtags/`,
  PostLikeToggle: `${BASE_URL}${APP_PREFIX}PostLike/toggle`,
   PostCommentToggle: `${BASE_URL}${APP_PREFIX}PostCommentLike/toggle`,

    PostComment: `${BASE_URL}${APP_PREFIX}PostComment`,

  CHAT_HUB_URL: `${HUB_URL}/hubs/chat`,
  NOTIFICATION_HUB_URL: `${HUB_URL}/hubs/notifications`,
  PhotoLike: `${BASE_URL}${APP_PREFIX}UserPhotoInteraction`,
  CheckPhotoLike: `${BASE_URL}${APP_PREFIX}UserPhotoInteraction`,
  PhotoLikeCount: `${BASE_URL}${APP_PREFIX}UserPhotoInteraction`,
  DeleteUserAccount: `${BASE_URL}${APP_PREFIX}UserProfiles`,
  PhotoLikeBy: `${BASE_URL}${APP_PREFIX}UserPhotoInteraction`,
  VALIDATE_NPI_NUMBER: `${BASE_URL}${APP_PREFIX}UserProfiles/validate-npi`,
  Admin_AvailabilityType: `${BASE_URL}app/Masters/Availability-Types`,
  Admin_ExploreTechnologiesCategory: `${BASE_URL}admin/InterestCategory`,
  Admin_ExploreTechnologies: `${BASE_URL}app/Masters/Interest-Service`,
  GetAllGroups: `${BASE_URL}${APP_PREFIX}Group`,
  AddMembersToExistingGroup: `${BASE_URL}${APP_PREFIX}Group/members/add`,
  SavedLists: `${BASE_URL}${APP_PREFIX}SavedList`,
  SavedListById: (id: string | number) => `${BASE_URL}${APP_PREFIX}SavedList/${id}`,

  WISHLIST: `${BASE_URL}${APP_PREFIX}wishlist`,
  WISHLIST_UPDATE: (id: number) => `${BASE_URL}${APP_PREFIX}wishlist/${id}`,
  WISHLIST_LIKE: (id: number) => `${BASE_URL}${APP_PREFIX}wishlist/${id}/like`,
  WISHLIST_LIKES: (id: number) => `${BASE_URL}${APP_PREFIX}wishlist/${id}/likes`,
  WISHLIST_REORDER: `${BASE_URL}${APP_PREFIX}wishlist/reorder`,
};

/**
 * Helper function to build query string
 * @param params - Object with query parameters
 * @returns Query string
 */
export const buildQueryString = (params: Record<string, any>): string => {
  const query = Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  return query ? `?${query}` : '';
};

/**
 * Helper function to get full URL with query params
 * @param baseUrl - Base URL
 * @param params - Query parameters
 * @returns Full URL with query string
 */
export const getUrlWithParams = (baseUrl: string, params?: Record<string, any>): string => {
  if (!params) return baseUrl;
  return `${baseUrl}${buildQueryString(params)}`;
};

export default apiVariables;
